import sanitizeHtml from 'sanitize-html';

/**
 * [createSanitizedHtmlObject]
 * Returns sanitized a html object when passed html
 */
export const createSanitizedHtmlObject = (storyHtml) => {
  return {
    __html: sanitizeHtml(storyHtml),
  };
};
